<template>
    <div>
        <div class="" >
            <img src="../assets/svg/null.svg" style="width: 96px; height: 96px;"/>
            <div style="color: #666;padding: 15px 0;cursor: default">
                <span>查询无结果</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "nullPage"
    }
</script>

<style scoped>

</style>

